// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"e2e1bd8a","518":"b925c0c7","618":"6e205b72","905":"761ac524","926":"da01a084","989":"7b864291"}[chunkId] + ".chunk.js";
};